import { 
  getTaobaoGoodsInfo, 
  getTaobaoUrl, 
  jdGoodsInfoNew, 
  GetJdUrl, 
  pddGoodsInfoNew, 
  getPddUrl, 
  vipGoodsInfo, 
  vipGetUrl, 
  getGoodsInfo, 
  getKsUrl, 
  storePromotionUrl, 
  douyinGoodsInfo, 
  getDouyinUrl, 
  getMediaLink, 
  fullSearchLive, 
  getUrlLive,
  getXianYuUrl,
  getXianGoodsInfo
} from '@/api/public'

const PLATFORM_TYPE = {
  1: '淘宝',
  2: '淘宝',
  3: '京东',
  4: '拼多多',
  9: '唯品会',
  12: '苏宁',
  16: '美团',
  22: '快手',
  25: '抖音',
  33: '淘宝直播',
  34: '闲鱼'
}

class GoodsHandler {
  constructor() {
    this.loading = false
  }

  // 主要的商品详情处理方法
  async handleGoodsDetail(item, options = {}) {
    const { teamType = 1, onLoadingChange, onSuccess, onError } = options
    

    
    if (teamType == 2) {
      return false
    }

    this.loading = true
    if (onLoadingChange) onLoadingChange(true)

    try {
      let result = null
      
      // 适配不同的数据结构 - 订单页面使用type_new，榜单页面使用type
      const platformType = Number(item.type || item.type_new)
      
      switch (platformType) {
        case 1:
        case 2:
          result = await this.handleTaobao(item)
          break
        case 3:
          result = await this.handleJingdong(item)
          break
        case 4:
          result = await this.handlePinduoduo(item)
          break
        case 9:
          result = await this.handleVip(item)
          break
        case 12:
          result = await this.handleSuning(item)
          break
        case 16:
          result = await this.handleMeituan(item)
          break
        case 22:
          result = await this.handleKuaishou(item)
          break
        case 25:
          result = await this.handleDouyin(item)
          break
        case 33:
          result = await this.handleTaobaoLive(item)
          break
        case 34:
          result = await this.handleXianYu(item)
          break
        default:
          throw new Error('暂不支持转链')
      }

             this.loading = false
       if (onLoadingChange) onLoadingChange(false)

       if (result && onSuccess) {
         onSuccess(result)
       }

       return result

    } catch (error) {
      this.loading = false
      if (onLoadingChange) onLoadingChange(false)
      
      if (onError) {
        onError(error.message || '转链失败')
      }
      
      throw error
    }
  }

  // 淘宝商品处理
  async handleTaobao(item) {
    try {
      // 适配不同页面的字段名 - 订单页面有goods_id字段，榜单页面需要从origin_id解析
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await getTaobaoGoodsInfo({
        num_iid: goodsId
      })

      if (res.data.origin_id) {
        const opt = await getTaobaoUrl({
          num_iid: res.data.origin_id,
          activityId: res.data.quan_id,
          need_tbk_pwd: 1,
          need_short_url: 1,
          title: item.title || item.full_title,
          model: 'ios',
        })

        const random = Math.floor(Math.random() * 10)
        return {
          pageUrl: opt.data.tb_url,
          ptw: random + opt.data.tbk_pwd
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 京东商品处理
  async handleJingdong(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await jdGoodsInfoNew({
        id: goodsId
      })

      if (res.data.origin_id) {
        const opt = await GetJdUrl({
          id: res.data.origin_id,
          data_type: 1,
          url: res.data.quan_link,
        })

        return {
          pageUrl: opt.data.url,
          ptw: opt.data.j_short_command
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 拼多多商品处理
  async handlePinduoduo(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await pddGoodsInfoNew({
        id: goodsId
      })

      if (res.data.origin_id) {
        const opt = await getPddUrl({
          id: res.data.origin_id,
          multi_group: 0,
        })

        return {
          pageUrl: opt.data.short_url,
          ptw: null
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 唯品会商品处理
  async handleVip(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await vipGoodsInfo({
        origin_id: goodsId
      })

      if (res.data.origin_id) {
        const opt = await vipGetUrl({
          origin_id: res.data.origin_id,
        })

        return {
          pageUrl: opt.data.url.url,
          ptw: null
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 苏宁商品处理
  async handleSuning(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const opt = await storePromotionUrl({
        commCode: goodsId,
        mertCode: item.seller_id
      })

      return {
        pageUrl: opt.data.pcExtendUrl,
        ptw: null
      }
    } catch (error) {
      return null
    }
  }

  // 美团商品处理
  async handleMeituan(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await getMediaLink({
        skuViewId: goodsId
      })
      if (res.data.url) {
        return {
          pageUrl: res.data.url,
          ptw: res.data.group_password
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 快手商品处理
  async handleKuaishou(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await getGoodsInfo({
        originId: goodsId
      })

      if (res.data.origin_id) {
        const opt = await getKsUrl({
          linkCarrierId: res.data.origin_id,
        })

        return {
          pageUrl: opt.data.linkUrl,
          ptw: opt.data.linkCode
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 抖音商品处理
  async handleDouyin(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await douyinGoodsInfo({
        origin_id: goodsId
      })

      if (res.data.origin_id) {
        const opt = await getDouyinUrl({
          origin_id: res.data.origin_id,
        })

        return {
          pageUrl: opt.data.share_link,
          ptw: opt.data.dy_password
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 淘宝直播商品处理
  async handleTaobaoLive(item) {
    try {
      const goodsId = item.goods_id || this.extractGoodsId(item)
      
      const res = await fullSearchLive({
        object_ids: goodsId
      })

      if (res.data.list && res.data.list.length > 0) {
        const opt = await getUrlLive({
          origin_id: res.data.list[0].origin_id,
        })

        return {
          pageUrl: opt.data.short_url,
          ptw: opt.data.tbk_pwd
        }
      }
      return null
    } catch (error) {
      return null
    }
  }

  // 闲鱼商品处理
    async handleXianYu(item) {
      try {
        const goodsId = item.goods_id || this.extractGoodsId(item)
        
        const res = await getXianGoodsInfo({
          origin_id: goodsId
        })
  
        if (res.data.origin_id) {
          const opt = await getXianYuUrl({
            origin_id: res.data.origin_id,
          })
  
          return {
            pageUrl: opt.data.short_url,
            ptw: opt.data.short_tpwd
          }
        }
        return null
      } catch (error) {
        return null
      }
    }

  // 获取平台名称
  getPlatformName(type) {
    return PLATFORM_TYPE[type] || '未知平台'
  }

  // 检查是否正在加载
  isLoading() {
    return this.loading
  }

  // 从origin_id中提取商品ID（用于榜单页面）
  extractGoodsId(item) {
    if (!item.origin_id) return null
    try {
      const decodedId = decodeURIComponent(item.origin_id)
      const parts = decodedId.split('|')
      return parts[1] || parts[0] // 返回第二部分或第一部分
    } catch (error) {
      console.error('提取商品ID失败:', error)
      return item.origin_id
    }
  }
}

// 创建单例实例
const goodsHandler = new GoodsHandler()

export default goodsHandler 